//桌面端导航栏

import { AppBar, Toolbar, Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../pages/action";
import LogoutConfirmDialog from "../../LogoutConfirmDialog";

const StyledAppBar = styled(AppBar)`
  background: transparent;
  box-shadow: none;
  transition: all 0.3s ease;
  z-index: 1200;

  &:hover {
    background: transparent;
  }
`;

const LogoWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;

  img {
    width: 96px;
    height: 96px;
  }
`;

const NavLinksWrapper = styled(Box)`
  margin-left: auto;
  display: flex;
  gap: 40px;

  a {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
    font-size: 0.925rem;
    font-weight: 400;
    transition: all 0.2s ease;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      bottom: -4px;
      left: 0;
      width: 0;
      height: 1px;
      background: rgba(255, 255, 255, 0.9);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &:hover {
      color: rgba(255, 255, 255, 1);
      &::after {
        width: 100%;
      }
    }

    &.active {
      color: rgba(255, 255, 255, 1);
      &::after {
        width: 100%;
      }
    }
  }
`;

const DesktopNavbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // 从 Redux 获取登录状态
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const handleNavLinkClick = (path) => {
    navigate(path);
  };

  // 处理登录/登出按钮点击
  const handleAuthClick = (e) => {
    e.preventDefault();

    if (isLoggedIn) {
      // 已登录，显示确认对话框
      setLogoutDialogOpen(true);
    } else {
      // 未登录，导航到登录页面
      navigate("/login");
    }
  };

  // 添加确认登出的处理函数
  const handleConfirmLogout = () => {
    // 执行登出操作
    dispatch(logout());
    localStorage.removeItem("token");
    localStorage.removeItem("refreshtoken");
    localStorage.removeItem("username");
    navigate("/");
    setLogoutDialogOpen(false);
  };

  return (
    <StyledAppBar position="static">
      <Toolbar sx={{ height: "80px", px: "48px" }}>
        <LogoWrapper>
          <img src="/images/logo/logowhite.svg" alt="3CCA Logo" />
          <Typography
            variant="h6"
            sx={{
              fontSize: "1.1rem",
              fontWeight: 500,
              color: "rgba(255, 255, 255, 0.95)",
              letterSpacing: "-0.03em",
              textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
            }}
          >
            3CCA(基督徒联盟)
          </Typography>
        </LogoWrapper>

        <NavLinksWrapper>
          <Link
            to="/"
            className={location.pathname === "/" ? "active" : ""}
            onClick={(e) => {
              e.preventDefault();
              handleNavLinkClick("/");
            }}
          >
            主页
          </Link>

          <Link
            to="/intro"
            className={location.pathname === "/intro" ? "active" : ""}
            onClick={(e) => {
              e.preventDefault();
              handleNavLinkClick("/intro");
            }}
          >
            简介
          </Link>

          <Link
            to="/worship"
            className={location.pathname === "/worship" ? "active" : ""}
            onClick={(e) => {
              e.preventDefault();
              handleNavLinkClick("/worship");
            }}
          >
            3CCA崇拜
          </Link>
          <Link
            to="/vision"
            className={location.pathname === "/vision" ? "active" : ""}
            onClick={(e) => {
              e.preventDefault();
              handleNavLinkClick("/vision");
            }}
          >
            异象空间
          </Link>
          <Link
            to="/serve"
            className={location.pathname === "/serve" ? "active" : ""}
            onClick={(e) => {
              e.preventDefault();
              handleNavLinkClick("/serve");
            }}
          >
            事奉同工
          </Link>
          <Link
            to="/contact"
            className={location.pathname === "/contact" ? "active" : ""}
            onClick={(e) => {
              e.preventDefault();
              handleNavLinkClick("/contact");
            }}
          >
            奉献
          </Link>
          <Link
            to="/administration"
            className={location.pathname === "/administration" ? "active" : ""}
            onClick={(e) => {
              e.preventDefault();
              handleNavLinkClick("/administration");
            }}
          >
            管理
          </Link>

          {/* 登录/登出按钮 */}
          <Link
            to="#"
            className={
              location.pathname === "/login" && !isLoggedIn ? "active" : ""
            }
            onClick={handleAuthClick}
          >
            {isLoggedIn ? "登出" : "登录"}
          </Link>
        </NavLinksWrapper>
      </Toolbar>
      <LogoutConfirmDialog
        open={logoutDialogOpen}
        onClose={() => setLogoutDialogOpen(false)}
        onConfirm={handleConfirmLogout}
        username={useSelector((state) => state.auth.username)}
      />
    </StyledAppBar>
  );
};

export default DesktopNavbar;
